export const state = {
    name: "",
    description: "",
    status: null
};